import React, { useState, useCallback } from 'react';
import { View, Responsive } from '@smarterservices/smarter-ui';
import { useExamSessionStore, getStore } from '../../../stores/StoreContext';
import SessionInitializing from './SessionInitializing';
import SessionLoading from './SessionLoading';
import SessionDisconnected from './SessionDisconnected';
import SessionTransferred from './SessionTransferred';
import SessionEnded from './SessionEnded';
import CONSTANTS from '../../../config/constants';

const SessionOverlays = () => {
  const currentOverlay = useExamSessionStore((state) => state.currentOverlay);
  const lastConnectionChange = useExamSessionStore((state) => state.lastConnectionChange);
  const overlayStack = useExamSessionStore((state) => state.overlayStack);
  const [containerElement, setContainerElement] = useState(null);

  const containerRef = useCallback((node) => {
    if (node !== null) {
      setContainerElement(node);
    }
  }, []);

  return (
    <View
      as="div"
      elementRef={containerRef}
      width="100%"
      height="100%"
      display="block"
      background="primary"
    >
      {containerElement && (
        <Responsive
          match="element"
          elementRef={() => containerElement}
          query={{
            small: { maxWidth: 350 },
            medium: { minWidth: 350, maxWidth: 500 },
            large: { minWidth: 500 }
          }}
          props={{
            small: { size: 'small', iconSize: 'small', titleVariant: 'h3', padding: 'small', showExpandedInfo: false },
            medium: { size: 'medium', iconSize: 'medium', titleVariant: 'h2', padding: 'medium', showExpandedInfo: false },
            large: { size: 'large', iconSize: 'large', titleVariant: 'h2', padding: 'large', showExpandedInfo: true }
          }}
          render={(props, matches) => {
            return (
              <>
                {currentOverlay === CONSTANTS.OVERLAYS.SESSION.LOADING.NAME && <SessionLoading lastConnectionChange={lastConnectionChange} {...props} />}
                {currentOverlay === CONSTANTS.OVERLAYS.SESSION.INITIALIZING.NAME && <SessionInitializing lastConnectionChange={lastConnectionChange} {...props} />}
                {currentOverlay === CONSTANTS.OVERLAYS.SESSION.DISCONNECTED.NAME && <SessionDisconnected lastConnectionChange={lastConnectionChange} {...props} />}
                {currentOverlay === CONSTANTS.OVERLAYS.SESSION.TRANSFERRED.NAME && <SessionTransferred lastConnectionChange={lastConnectionChange} {...props} />}
                {currentOverlay === CONSTANTS.OVERLAYS.SESSION.ENDED.NAME && <SessionEnded lastConnectionChange={lastConnectionChange} {...props} />}
              </>
            )
          }}
        />
      )}
    </View>
  );
};

export default SessionOverlays;
